var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOfficeHours = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77501 0C6.35491 0 6.82501 0.470101 6.82501 1.05V1.575H14.175V1.05C14.175 0.470101 14.6451 0 15.225 0C15.8049 0 16.275 0.470101 16.275 1.05V1.575H18.375C19.3898 1.575 20.2125 2.39768 20.2125 3.4125V19.1625C20.2125 20.1773 19.3898 21 18.375 21H2.62501C1.61018 21 0.787506 20.1773 0.787506 19.1625V3.4125C0.787506 2.39768 1.61018 1.575 2.62501 1.575H4.72501V1.05C4.72501 0.470101 5.19511 0 5.77501 0ZM4.72501 3.675H2.88751V6.3H18.1125V3.675H16.275V4.2C16.275 4.7799 15.8049 5.25 15.225 5.25C14.6451 5.25 14.175 4.7799 14.175 4.2V3.675H6.82501V4.2C6.82501 4.7799 6.35491 5.25 5.77501 5.25C5.19511 5.25 4.72501 4.7799 4.72501 4.2V3.675ZM18.1125 8.4H2.88751V18.9H18.1125V8.4Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOfficeHours);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/office-hours.2aae4c16d238314c12d5da04c584545f.svg";